import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import "../styles/login.css";
import globals from '../globals.js';
import { setCookie, getCookies } from "../controllers/cookies.controller";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Verifica se já está logado ao carregar a página
    useEffect(() => {
        const token = getCookies('token');
        if (token) {
            // Se já tem token, redireciona para área do cliente
            navigate('/minha-assinatura');
        }
    }, [navigate]);

    const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError("");

        try {
            // Criar FormData para enviar como application/x-www-form-urlencoded
            const formData = new URLSearchParams();
            formData.append('email', email);
            formData.append('senha', password);

            const response = await fetch(`${globals.apiBaseUrl}/api/contratoonline/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            });

            const responseData = await response.json();

            if (responseData.status === 'sucess' && responseData.token) {
                setCookie('token', responseData.token, 7);
                navigate('/minha-assinatura');
            } else {
                throw new Error(responseData.msg || 'Email ou senha incorretos.');
            }
        } catch (error: any) {
            console.error('Erro:', error);
            setError(error.message || 'Ocorreu um erro ao fazer login. Tente novamente.');
        }
    };

    return (
        <React.Fragment>
            <Header />
            <form className="main-form-container" onSubmit={handleLogin}>
                {error && <div className="main-error-message">{error}</div>}
                <b className="main-header">Login</b>

                <div className="form-group">
                    <span>E-MAIL</span>
                    <input type="email" name="email" id="emailEl" placeholder="exemplo@2k20.com.br" required value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="form-group">
                    <span>SENHA</span>
                    <input type="password" name="password" id="passwordEl" required value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <button type="submit">Entrar</button>

                <div className="login-links">
                    <Link to="/recuperar-senha">Esqueci minha senha</Link>
                </div>
            </form>
        </React.Fragment>
    );
};

export default Login;
